import { Trash } from "@phosphor-icons/react"
import { useState } from "react"

import { Button } from "~/components/reusable/Button"
import {
  DialogClose,
  DialogContentV2,
  DialogFooterV2,
  DialogHeaderV2,
  DialogBodyV2,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from "~/components/reusable/Dialog"
import { useRemoveVariantsFromCollection } from "~/hooks/useCollections"

type Props = {
  variantIds: string[]
  collectionId: number
  onSuccess?: () => void
  disabled?: boolean
  disabledTooltip?: string
}

export const RemoveVariantsFromCollectionDialog = ({
  variantIds,
  collectionId,
  onSuccess,
  disabled,
  disabledTooltip,
}: Props) => {
  const [open, setOpen] = useState(false)

  const { mutate: removeVariants, isPending: isRemovingVariants } =
    useRemoveVariantsFromCollection()

  const handleOpenChange = (open: boolean) => {
    setOpen(open)
  }

  const onSubmit = () => {
    removeVariants(
      {
        collectionId,
        variantIds,
      },
      {
        onSuccess: () => {
          setOpen(false)
          onSuccess?.()
        },
      },
    )
  }

  return (
    <DialogRoot open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger
        requires="edit"
        asChild
        disabled={disabled}
        allowedTitle={disabled ? disabledTooltip : undefined}
      >
        <Button size="sm" variant="neutral">
          <Trash />
          Remove
        </Button>
      </DialogTrigger>
      <DialogContentV2>
        <DialogHeaderV2>
          <DialogTitle>Remove variants from collection</DialogTitle>
        </DialogHeaderV2>
        <DialogBodyV2>
          <p className="text-sm">
            You are about to remove the selected variants from the collection. Are you sure you want
            to proceed?
          </p>
        </DialogBodyV2>
        <DialogFooterV2 className="justify-end gap-2">
          <DialogClose>
            <Button asChild variant="transparent">
              Cancel
            </Button>
          </DialogClose>
          <Button variant="danger" requires="edit" onClick={onSubmit} loading={isRemovingVariants}>
            {isRemovingVariants ? "Removing variants..." : "Remove variants"}
          </Button>
        </DialogFooterV2>
      </DialogContentV2>
    </DialogRoot>
  )
}
